/* Back in stock "Notify me when available" (own, replaces the Kbite app). 20 Oct 2026.
 *
 * The button sits under the product form (snippets/product-content.liquid) and shows only
 * while the theme's Add to basket button is disabled (the selected variant is sold out).
 * The window posts to the app proxy /apps/sh/bis/subscribe; Shopify signs the request and
 * the shopify-xero server (server/back-in-stock.js) saves it. The email goes out when the
 * variant is back in the warehouse. Styles: snippets/css-sh-bis.liquid.
 * The wrapper keeps Kbite's class gw-button-widget-container so the wishlist heart
 * (sh-wishlist.js placeHeart) still sits beside the button.
 */
(function () {
  'use strict';
  var API = '/apps/sh/bis/subscribe';
  var modal = null, lastFocus = null, current = null;

  // The selected variant. The theme updates the page address (?variant=) and the LAST
  // name="id" inputs; the first one in the form keeps the variant the page loaded with.
  function variantOf(form, box) {
    var known = [];
    try { known = JSON.parse(box.getAttribute('data-variants') || '[]').map(function (x) { return String(x.id); }); } catch (e) {}
    var fromUrl = new URLSearchParams(location.search).get('variant');
    if (fromUrl && known.indexOf(fromUrl) !== -1) return fromUrl;
    var inputs = form ? form.querySelectorAll('[name="id"]') : [];
    return inputs.length ? inputs[inputs.length - 1].value : (known[0] || '');
  }

  function variantTitle(box, vid) {
    try {
      var data = JSON.parse(box.getAttribute('data-variants') || '[]');
      for (var i = 0; i < data.length; i++) if (String(data[i].id) === String(vid)) return data[i].title;
    } catch (e) {}
    return '';
  }

  // Show the button only when Add to basket is disabled (sold out).
  function sync() {
    document.querySelectorAll('[data-sh-bis]').forEach(function (box) {
      var form = box.closest('form');
      var add = form && form.querySelector('.product-form-add-wr .cartButton');
      var soldOut = !!(add && add.classList.contains('disabled'));
      // A class, not the hidden attribute: the wishlist heart watches class changes to move beside it.
      box.classList.toggle('sh-bis--off', !soldOut);
    });
  }

  function el(tag, attrs, text) {
    var e = document.createElement(tag);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (text != null) e.textContent = text;
    return e;
  }

  function buildModal() {
    modal = el('div', { class: 'sh-bis-modal', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'sh-bis-title', hidden: '' });
    modal.innerHTML =
      '<div class="sh-bis-modal__panel">' +
        '<button type="button" class="sh-bis-modal__close" aria-label="Close" data-sh-bis-close>&times;</button>' +
        '<div class="sh-bis-modal__form">' +
          '<h2 class="sh-bis-modal__title" id="sh-bis-title">Notify me when available</h2>' +
          '<p class="sh-bis-modal__product"></p>' +
          '<form novalidate>' +
            '<label class="visually-hidden" for="sh-bis-email">Email address</label>' +
            '<input type="email" id="sh-bis-email" name="email" class="sh-bis-modal__email" placeholder="Email address" autocomplete="email" required>' +
            '<label class="sh-bis-modal__optin"><input type="checkbox" name="optin"> <span>Also send me Stacked Store news and offers</span></label>' +
            '<p class="sh-bis-modal__error" role="alert" hidden></p>' +
            '<button type="submit" class="sh-bis-modal__submit">Notify me</button>' +
          '</form>' +
          '<p class="sh-bis-modal__note">We\'ll email you once, as soon as it\'s back online.</p>' +
        '</div>' +
        '<div class="sh-bis-modal__done" hidden>' +
          '<h2 class="sh-bis-modal__title">You\'re on the list</h2>' +
          '<p class="sh-bis-modal__done-text"></p>' +
          '<button type="button" class="sh-bis-modal__submit" data-sh-bis-close>Continue shopping</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-sh-bis-close]')) close();
    });
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') { // keep focus inside the window
        var f = [].filter.call(modal.querySelectorAll('button, input'), function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    modal.querySelector('form').addEventListener('submit', submit);
  }

  function open(box) {
    if (!modal) buildModal();
    var form = box.closest('form');
    var vid = variantOf(form, box);
    var vt = variantTitle(box, vid);
    current = { p: box.getAttribute('data-product-id'), v: vid };
    var name = box.getAttribute('data-product-title') + (vt && vt !== 'Default Title' ? ' - ' + vt : '');
    modal.querySelector('.sh-bis-modal__product').textContent = name;
    modal.querySelector('.sh-bis-modal__form').hidden = false;
    modal.querySelector('.sh-bis-modal__done').hidden = true;
    var err = modal.querySelector('.sh-bis-modal__error'); err.hidden = true; err.textContent = '';
    var email = modal.querySelector('.sh-bis-modal__email');
    if (!email.value) email.value = box.getAttribute('data-customer-email') || '';
    var btn = modal.querySelector('form .sh-bis-modal__submit'); btn.disabled = false; btn.textContent = 'Notify me';
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('sh-bis-open');
    setTimeout(function () { email.focus(); }, 30);
  }

  function close() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.classList.remove('sh-bis-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function showError(msg) {
    var err = modal.querySelector('.sh-bis-modal__error');
    err.textContent = msg; err.hidden = false;
  }

  function submit(e) {
    e.preventDefault();
    var form = e.target;
    var email = form.email.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { showError('Please enter a valid email address.'); form.email.focus(); return; }
    if (!current || !current.v) { showError('Please choose an option first.'); return; }
    var btn = form.querySelector('.sh-bis-modal__submit');
    btn.disabled = true; btn.textContent = 'Saving...';
    fetch(API, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ email: email, v: current.v, p: current.p, optin: form.optin.checked })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; });
    }).then(function (res) {
      if (!res.ok || !res.j.ok) {
        btn.disabled = false; btn.textContent = 'Notify me';
        showError(res.j && res.j.error === 'too many'
          ? 'This email is already waiting for a lot of items. Please contact customercare@stackedstore.com.'
          : 'Sorry, that didn\'t work. Please try again.');
        return;
      }
      modal.querySelector('.sh-bis-modal__done-text').textContent = (res.j.already
        ? 'You were already on the list. '
        : '') + 'We\'ll email ' + email + ' as soon as ' + modal.querySelector('.sh-bis-modal__product').textContent + ' is back.';
      modal.querySelector('.sh-bis-modal__form').hidden = true;
      modal.querySelector('.sh-bis-modal__done').hidden = false;
      modal.querySelector('.sh-bis-modal__done .sh-bis-modal__submit').focus();
      try {
        if (window.dataLayer) window.dataLayer.push({ event: 'back_in_stock_signup', product_id: current.p, variant_id: current.v });
      } catch (e2) {}
    }).catch(function () {
      btn.disabled = false; btn.textContent = 'Notify me';
      showError('Sorry, that didn\'t work. Please check your connection and try again.');
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sh-bis-open]');
    if (b) { e.preventDefault(); open(b.closest('[data-sh-bis]')); }
  });
  document.addEventListener('change', function (e) {
    if (e.target.closest('form[action*="/cart/add"]')) setTimeout(sync, 60);
  });
  if ('MutationObserver' in window) {
    document.querySelectorAll('product-form').forEach(function (pf) {
      new MutationObserver(function () { setTimeout(sync, 0); })
        .observe(pf, { subtree: true, attributes: true, attributeFilter: ['class'] });
    });
  }
  sync();
})();
